import React, { useEffect } from "react";
import { Card, CardBody, CardHeader } from "@nextui-org/react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";
import ServiceForm from "./ServiceForm";
import BackToButton from "../common/BackToButton";
import { all_routes } from "../router/all_routes";
import { useStore } from "../../app/stores/store";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const ServiceCreate = () => {

  const { t } = useTranslation();
  const navigate = useNavigate();
  const{userStore}=useStore();

  useEffect(() => {
    if (!userStore.isAdmin()) {
      navigate("/login");
      toast.error("Unauthorized");
    } 
  }, [userStore.token]);

  return (
    <>
      <Card className="mt-5 mb-20 custom-container">
        <CardHeader className="flex justify-between gap-3 flex-wrap">
       
            <div>
              <BackToButton
                href={all_routes.serviceDashboard}
                label="Back To Services"
              />
            </div>
            <div>
              <h1 className="text-3xl font-semibold">
                {t("Create Service")}
              </h1>
            </div>
      <div className="w-2/12"></div>
        </CardHeader>
        <CardBody className="flex flex-col gap-10">
          <ServiceForm />
        </CardBody>
      </Card>
    </>
  );
};

export default observer(ServiceCreate);
